module.exports = __webpack_public_path__ + "img/googleplay.9d29fa37.svg";